import { render, staticRenderFns } from "./chatbot-message-chart.vue?vue&type=template&id=1c39aa3d"
import script from "./chatbot-message-chart.vue?vue&type=script&lang=js"
export * from "./chatbot-message-chart.vue?vue&type=script&lang=js"
import style0 from "./chatbot-message-chart.vue?vue&type=style&index=0&id=1c39aa3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports